import { render, staticRenderFns } from "./trialBalanceArchiveBottom.vue?vue&type=template&id=2f0e9f90"
import script from "./trialBalanceArchiveBottom.vue?vue&type=script&lang=js"
export * from "./trialBalanceArchiveBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports